module.exports = __webpack_public_path__ + "static/img/pkbockbg.39680b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pkbockbg.png
// module id = dhZv
// module chunks = 1